@if (dfms?.isFormReadOnly != true || alwaysEditable) {
  @if (shown) {
    <input (click)="click()" [className]="cssClass" type="button" value="{{getAttribute('name')}}">
  }
  @if (showTooltip) {
    <div class="button-tooltip-container">
      <p class="tooltip-text button-tooltip-text">{{this.tooltipTextMessage}}</p>
    </div>
  }
}